import { ConversationIncludeOption } from '@clientwire/api';

/**
 * Include options used when hydrating the conversation stores in the team-facing app.
 * Contains CONVERSATION_DATA, which the backend rejects for client participants —
 * the client-app and embed-lib must keep passing their own include lists instead.
 */
export const CONVERSATION_STORE_INCLUDES: ConversationIncludeOption[] = [
  ConversationIncludeOption.Participants,
  ConversationIncludeOption.ConversationType,
  ConversationIncludeOption.ConversationData,
  ConversationIncludeOption.ListItemTemplateData,
  ConversationIncludeOption.ClientParticipantFrontendUrl,
  ConversationIncludeOption.ParticipantNotificationStatus,
];
